import React from "react";

import { RouteErrorBoundary } from "src/components/ErrorBoundary/RouteErrorBoundary.tsx";

import { ResourceRoute } from "src/framework/ResourceRoute.tsx";
import { queryClient } from "src/lib/react-query.tsx";
import { resourceFormConfigQuery } from "src/system/resourceFormConfigQuery.ts";
import { formTranslationsQuery } from "src/system/formTranslationsQuery.ts";
import { useResourceFormContext } from "src/components/Form/hooks/useResourceFormContext.ts";
import { ResourceFormLayout } from "src/components/Form/ResourceFormLayout.tsx";
import { FormAction } from "src/components/Form/Form.types.ts";

export type CreateCreateV2Props = {
  resource: string;
  layoutForm?: boolean;
  tab?: string;
};

export function createCreateV2({
  layoutForm,
  resource,
  tab,
}: CreateCreateV2Props) {
  const LayoutFormComponent = () => {
    const { layoutConfig } = useResourceFormContext();
    return <ResourceFormLayout config={layoutConfig} />;
  };
  const RegularComponent = () => {
    return <ResourceRoute type={FormAction.Create} resource={resource} />;
  };
  const Component = layoutForm ? LayoutFormComponent : RegularComponent;
  const ErrorBoundary = RouteErrorBoundary;
  const loader = async () => {
    if (!layoutForm) {
      // fetch in parallel
      await Promise.all([
        queryClient.ensureQueryData(
          resourceFormConfigQuery({
            resource: resource,
            action: FormAction.Create,
          }),
        ),
        queryClient.ensureQueryData(
          formTranslationsQuery({
            resource,
            action: FormAction.Create,
          }),
        ),
      ]);
    }

    return null;
  };
  return {
    Component,
    ErrorBoundary,
    loader,
  };
}
